import {router,currentRoute} from '@/router'
import { showToast } from 'vant'
import Clipboard from "clipboard";


export function _isMobile() {      
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)      
    return flag;    
}
export function isPhoneNumber(str) {
    var myreg = /^1[3456789]\d{9}$/;
    if (!myreg.test(str)) {
        return false;
    } else {
        return true;
    }
}

export function toCopy(){
    const clipboard = new Clipboard(".copy")
    clipboard.on('success', e => {
        showToast('复制成功')
        // this.$Toast(this.$lang.copy_success)
        // // 释放内存
        clipboard.destroy()
    })
    clipboard.on('error', e => {
        showToast('复制失败')
        // 不支持copy 
        // this.$Toast(this.$lang.browser_not_support)
        // 释放内存
        clipboard.destroy()
    })
}

export function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

export function starPhone(phoneNum){
    let str = String(phoneNum),
        strLen = str.slice(0, 3) +'****' + str.slice(str.length-4);
    return strLen;
}

export function Mathfloor (num){
    if(num){
      return  Math.floor(num)
    }else{
        return num
    }
}

export function getDecimalNumber(num) {
   return String(num).match(/\.(\d+)/)[1];
}


export function goLink(url,query){
    localStorage.removeItem('isBack')
    router.push({
        path:url,
        query:query
    })
}

export function goReplace(url){
    if(url && url.indexOf('?')!=-1){
        let arr = url.split('?')
        let path = arr[0]
        let queryArr = arr[1].split("&")
        let query = {}
        queryArr.forEach(item=>{
            let str = item.split('=')
            if(str.length){
                query[str[0]] = str[1]
            }
        })
        console.log(query)
        router.replace({
            path:path,
            query:query
        }) 
    }else{
        router.replace({
            path:url
        }) 
    }
}

export function mergedArray (array1,array2){
    let mergedArray = array1.concat(array2)
    .filter((item, index, self) =>
        index === self.findIndex((t) => (
            t.wordId === item.wordId
        ))
    );
    return mergedArray
}

export function goBack(){
    router.go(-1)
}

export function goToPreviousPage (url) {
    // 获取上一个页面的路由信息
    const previousRoute = router.options.history.state.back;
    // console.log(previousRoute)
    if (previousRoute == url) {
        router.go(-1)
    } else {
        // 处理没有上一个页面的情况，例如回到首页或显示错误信息
        goLink(url);
    }
};

export function filterSpaces(str){
    return str.replace(/\s/g, "")
}

export function sortArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // 生成一个随机索引
        [array[i], array[j]] = [array[j], array[i]]; // 交换元素
    }
    return array;
}

export function getRandomArr(arr, count) {
    if (count >= arr.length) {
      return arr;
    }
    // Fisher-Yates算法
    for (let i = arr.length - 1; i > 0; i--) {
      const randomIndex = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
    }
    return arr.slice(0, count);
  }

export function toToast(msg){
    showToast(msg)
}

export function getformToken(str){
    if(str){
        return str.substr(0,4)+'...'+str.substr(str.length-4)
    }else{
        return str
    }
  }

  export function checkSecPassword(password){
	//6位数字密码
	var myreg = /^\d{6}$/;
	if (!myreg.test(password)) {
		return false;
	} else {
		return true;
	}
}
export function checkPassword(password){
	//字母和数字组合的6-12位密码
	var myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
	if (!myreg.test(password)) {
		return false;
	} else {
		return true;
	}
}

export function openUrl(url) {
    let openInBrowser = (url) => {
        if (window.android) {
            window.android.callAndroid("open," + url)
            return;
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeExt) {
            window.webkit.messageHandlers.nativeExt.postMessage({ msg: 'open,' + url })
            return;
        }
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
            window.location.href = url;
            return;
        }
        window.open(url)
    }
    openInBrowser(url);
    return
  }
export function toSubStr(str){

}
  
export function getWeekday(date) {
  const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const weekday = new Date(date).getDay();
  return weekdays[weekday];
}


export function clickWordNum(id,number){
    let wordList = ''
    if(localStorage.getItem('word')){
    wordList = localStorage.getItem('word')
    let arr = wordList.split(',')
    let flag = false
    let arr1 = arr.filter(item=>{
        return item == id
    })
    if(arr1.length){
        flag = true
    }
    // console.log(wordList,flag,arr)

    if(arr.length<number){
        if(!flag){
        arr.push(id)
        localStorage.setItem('word',arr.join(','))
        return true
        }else{
        return true
        }
    }else{
        if(!flag){
        goLink('/lock')
        return false
        }else{
        return true
        }
    }

    }else{
    let arr = [id]
    wordList = arr.join(',')
    localStorage.setItem('word',wordList)
    return true
    }
}

export function isWeChat() {
  return /MicroMessenger/i.test(navigator.userAgent);
}